import React, { ReactNode } from 'react';
import { Routes, Route, RouteProps, Navigate } from 'react-router-dom';
import { Map, Dashboard, Monitoring } from 'screens';
import Dash from 'screens/Dashboard';
import Login from 'screens/Login';
import { useAuth } from 'contexts/AuthContext';

// interface IRoutes extends RouteProps
export type IRoutes = RouteProps & {
  routeName: string;
  isPrivate?: boolean;
};

function LandingRoute() {
  const { user } = useAuth();

  if (user) return <Navigate to="/map" replace />;

  return <Login />;
}

function AdminRoute({ children }: { children: ReactNode }) {
  const { isAdmin, user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/map" replace />;

  return <>{children}</>;
}

//TODO Remover outras rotas
const routesList: IRoutes[] = [
  {
    routeName: 'Inicio',
    path: '/',
    element: <LandingRoute />,
  },
  {
    routeName: 'Dashboard',
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    routeName: 'Gráficos Favoritos',
    path: '/favorites',
    element: <Dashboard />,
  },
  {
    routeName: 'Gráficos Ocultos',
    path: '/hidden',
    element: <Dashboard />,
  },
  {
    routeName: 'Dashboard',
    path: '/old',
    element: <Dash />,
  },
  {
    routeName: 'Mapa',
    path: '/map',
    element: <Map />,
  },
  {
    routeName: 'Monitoramento',
    path: '/monitoramento',
    element: (
      <AdminRoute>
        <Monitoring />
      </AdminRoute>
    ),
  },
  {
    routeName: 'Default',
    path: '*',
    element: <Navigate to="/" />,
  },
];

export function Router() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {routesList.map(({ routeName, ...rest }) => (
        <Route key={`${routeName}-${rest.path}`} {...rest} />
      ))}
    </Routes>
  );
}
